import PropTypes from 'prop-types';

import { Button, styled } from '@mui/joy'

export const ToggleButtonNew = styled(
Button, {
    slot: 'root',
    name: 'ToggleButton'
  }
)(({ theme, props }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'center',
  p: .5,
  color: props.active ? theme.palette.primary.surface : theme.vars.palette.background.solidColor ,
  px: 1,
  background: props.active ? theme.vars.palette.background.solidBg : theme.vars.palette.primary.surface, 
  '&:hover': {
    'filter': 'lighten(1)'
  },
  '6:active': {
    'filter': 'darken(1)'
  }
}))


export function ToggleButton({
  active = false,
  children,
  ...props
}) {
  return (
    <Button
      aria-label={active ? 'Active' : 'Inactive'}
      variant={active ? 'solid' : 'plain'}
      sx={(theme) => ({
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'center',
        p: .5,
        color: active ?  theme.palette.primary.solidColor : theme.palette.common.black,
        px: 1,
        background: active ? theme.vars.palette.primary.solidBg : theme.vars.palette.background.surface, 
        '&:hover': {
          'filter': 'lighten(1)'
        },
        '6:active': {
          'filter': 'darken(1)'
        }
      })}
      {...props }
    >
      {children}
    </Button>
  )
}

ToggleButton.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
}

